// extracted by extract-css-chunks-webpack-plugin
module.exports = {"root":"_2sXwv","modalControls":"Bvjxc","deleteBtnWrapper":"_Wx7h"};